import { render, staticRenderFns } from "./EditReport.vue?vue&type=template&id=7b22b934&scoped=true&"
import script from "./EditReport.vue?vue&type=script&lang=ts&"
export * from "./EditReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b22b934",
  null
  
)

export default component.exports